export interface LogoutDeps {
    /** The user's session token from the mirror, or null if absent. */
    token: string | null
    /** Client-direct POST to WAPI `/v2/logout.json` with the user token. */
    logoutRequest: (token: string) => Promise<void>
    /** Remove the localStorage `userAccessToken` mirror. */
    clearMirror: () => void
    /** Snowplow `setUserId` — called with `null` to clear identity. */
    setSnowplowUserId: (id: string | null) => void
    /** Datadog RUM `clearUser`. */
    clearRumUser: () => void
}

/**
 * Log out in place. Tells WAPI to invalidate the session (best-effort — a failed
 * call must not strand the user logged-in locally), then unconditionally clears the
 * local session: the mirror and the Snowplow/RUM identity. Never navigates and never
 * throws. Fires **no** structured event, matching ui-react's `logOut` (its
 * `postLogOutCleanUp` is just `setUserId(null)` + `clearUser`).
 */
export async function performLogout(deps: LogoutDeps): Promise<void> {
    if (deps.token) {
        try {
            await deps.logoutRequest(deps.token)
        } catch {
            // best-effort: the user still logs out locally even if WAPI is unreachable
        }
    }

    deps.clearMirror()
    deps.setSnowplowUserId(null)
    deps.clearRumUser()
}
